<template>
    <AdminNextIframe
        path="/integrations/mcp"
        :full-view="false"
        @back="onBack">
        <template #fallback>
            <p class="mcp-connector-empty">
                {{ $t('account.mcp_connector.missing_next_admin') }}
            </p>
        </template>
    </AdminNextIframe>
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'McpConnector',
    components: { AdminNextIframe },
    methods: {
        onBack() {
            const backRoute = this.$route.meta?.backRoute ?? 'profile';
            this.$router.push({ name: backRoute });
        },
    },
};
</script>

<style scoped>
.mcp-connector-empty {
    padding: 2rem;
    color: var(--color-text-secondary, #666);
}
</style>
